"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _About = _interopRequireDefault(require("../../../../molecules/About"));

var _SiteMap = _interopRequireDefault(require("../../../../molecules/SiteMap"));

var _Subscribe = _interopRequireDefault(require("../../../../molecules/Subscribe"));

var SubscriptionBannerBody = function SubscriptionBannerBody(props) {
  var bodyColor = props.bodyColor,
      pages = props.pages,
      pagesClassName = props.pagesClassName,
      services = props.services,
      subscribe = props.subscribe;

  var onSubmitLoading = function onSubmitLoading() {
    return new Promise(function (res) {
      return setTimeout(function () {
        return res();
      }, 1000);
    });
  };

  var PagesColumn = function PagesColumn() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "footer-page-".concat(pages[0].title)
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      className: pagesClassName,
      computer: 3,
      tablet: 4,
      only: "computer tablet",
      textAlign: "left"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h4",
      className: "site-footer-body-header"
    }, pages[0].title), /*#__PURE__*/_react["default"].createElement(_SiteMap["default"], {
      links: pages[0].pages
    })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      className: pagesClassName,
      mobile: 16,
      only: "mobile",
      textAlign: "center"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h4",
      className: "site-footer-body-header"
    }, pages[0].title), /*#__PURE__*/_react["default"].createElement(_SiteMap["default"], {
      links: pages[0].pages
    })));
  };

  var ServicesColumn = function ServicesColumn() {
    var servicesData = services.length > 2 ? services.slice(0, 2) : services;
    return servicesData.map(function (service, index) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "footer-service-".concat(service.title)
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        mobile: 2,
        only: "mobile"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 3,
        tablet: 5,
        mobile: 12,
        className: "footer-service-column"
      }, /*#__PURE__*/_react["default"].createElement(_About["default"], {
        header: service.title,
        withContainer: true,
        content: service.content,
        headerAs: "h4"
      })), index < servicesData.length - 1 ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 1,
        mobile: 2,
        only: "computer mobile"
      }) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        mobile: 2,
        only: "mobile"
      }));
    });
  };

  var SubscribeColumn = function SubscribeColumn() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 1,
      tablet: 3,
      mobile: 2,
      only: "computer mobile"
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: 3,
      textAlign: "center",
      only: "computer"
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      style: {
        textAlign: 'left',
        textTransform: 'none'
      }
    }, subscribe.header), /*#__PURE__*/_react["default"].createElement(_Subscribe["default"], {
      onSubmit: onSubmitLoading,
      placeholder: subscribe.placeholder,
      button: false
    })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      tablet: 10,
      mobile: 12,
      only: "tablet mobile",
      textAlign: "center"
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      style: {
        textAlign: 'center',
        textTransform: 'none'
      }
    }, subscribe.header), /*#__PURE__*/_react["default"].createElement(_Subscribe["default"], {
      onSubmit: onSubmitLoading,
      placeholder: subscribe.placeholder,
      button: false
    })));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: bodyColor,
      paddingTop: '2em',
      paddingBottom: '2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    tablet: 1,
    only: "computer tablet"
  }), /*#__PURE__*/_react["default"].createElement(PagesColumn, null), /*#__PURE__*/_react["default"].createElement(ServicesColumn, null), /*#__PURE__*/_react["default"].createElement(SubscribeColumn, null), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    tablet: 1,
    only: "computer tablet"
  })));
};

SubscriptionBannerBody.propTypes = {
  bodyColor: _propTypes["default"].string.isRequired,
  pagesClassName: _propTypes["default"].string
};
SubscriptionBannerBody.defaultProps = {
  pagesClassName: 'footer-pages'
};
var _default = SubscriptionBannerBody;
exports["default"] = _default;